import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    HostBinding,
    HostListener,
    Input,
} from "@angular/core";
import { SortDirection } from "@spscommerce/ds-shared";
import { AttributePresenceInput } from "@spscommerce/ng-utils";

import { PinnableTableCell } from "../pinnable-table-cell";

@Component({
    selector: "sps-table-header, sps-th",
    templateUrl: "./sps-table-header.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsTableHeaderComponent extends PinnableTableCell {
    static readonly displayName = "sps-table-header / sps-th";
    static readonly props = {
        ...PinnableTableCell.props,
        sortKey: "string",
        controlCell: "boolean",
    };

    @HostBinding("attr.role") readonly _roleAttr = "columnheader";
    @HostBinding("class.sps-table__header") readonly _spsTableHeaderClass = true;

    @HostBinding("attr.aria-sort")
    get _ariaSortAttr() {
        return this.sort || "none";
    }

    @HostBinding("attr.tabIndex")
    get _tabIndexAttr() {
        return this.sortKey ? 0 : null;
    }

    sort: SortDirection;
    sortFlipped = new EventEmitter<SortDirection>();

    @Input() sortKey: string;

    @HostBinding("class.sps-table__header--sort-disabled")
    get unsortable() {
        return !this.sortKey;
    }

    @Input()
    @AttributePresenceInput()
    @HostBinding("class.sps-table__header--control")
    controlCell: boolean;

    @HostBinding("class.sps-table__header--sorted-asc")
    get isSortedAscending() {
        return this.sort === SortDirection.ASCENDING;
    }

    @HostBinding("class.sps-table__header--sorted-desc")
    get isSortedDescending() {
        return this.sort === SortDirection.DESCENDING;
    }

    constructor(
        protected changeDetector: ChangeDetectorRef,
        public elementRef: ElementRef
    ) {
        super();
    }

    @HostListener("keydown", ["$event"])
    onKeyDown(event: KeyboardEvent) {
        if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
            event.preventDefault();
            this.flipSort();
        }
    }

    flipSort() {
        if (this.sortKey && !this.controlCell) {
            this.sort = this.sort === SortDirection.ASCENDING
                ? SortDirection.DESCENDING
                : SortDirection.ASCENDING;
            this.sortFlipped.emit(this.sort);
        }
    }

    removeSort() {
        this.sort = undefined;
    }
}
